import { buildAction } from 'store/actions/actionCreator'

import { FETCH_GROUP } from './constants'

export const fetchGroup = buildAction(FETCH_GROUP, 'payload')
